<!--
/**
* @name: List.vue
* @description: 门店等级管理列表页
* @author: 杨波
* @create: 2020/11/26 14:40:37
* @update: 2020/11/26 14:40:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择门店等级" block clearable v-model="para.shopGrade">
          <k-option v-for="item in shopGradeList" :key="item.value" :value="item.value" :label="item.name" :selected="para.shopGrade == item.value">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAdd">新建</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination v-if="dataList && dataList.length" :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <!-- 新增/编辑弹窗区域 start -->
    <k-popup bind="v-if" okText="保存" title="门店等级信息" :show.sync="isPopupShow" @after-ok="onSave">
      <div style="width: 650px;">
        <y-form titleAlign="right" titleWidth="100px" contentWidth="320px">
          <y-form-item title="门店等级：" required>
            <k-select placeholder="请选择门店等级" block clearable v-model="editPara.shopGrade">
              <k-option v-for="item in shopGradeList" :key="item.value" :value="item.value" :label="item.name" :selected="editPara.shopGrade == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="员工数量：" required>
            <k-input @keydown.native="clearInput" min="0" type="number" placeholder="请输入员工数量" block clearable v-model="editPara.shopStaffNum"></k-input>
          </y-form-item>
          <y-form-item title="推广人数量：" required>
            <k-input @keydown.native="clearInput" min="0" type="number" placeholder="请输入推广人数量" block clearable v-model="editPara.shopPromotionNum"></k-input>
          </y-form-item>
          <y-form-item title="是否控货：">
            <k-select placeholder="请选择是否控货" block v-model="editPara.isControlGoods">
              <k-option v-for="item in controlList" :key="item.value" :value="item.value" :label="item.label" :selected="editPara.isControlGoods == item.value">{{ item.label }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="价格等级：">
            <k-select placeholder="请选择价格等级" block clearable v-model="editPara.priceGrade">
              <k-option v-for="item in priceGradeList" :key="item.value" :value="item.value" :label="item.label" :selected="editPara.priceGrade == item.value">{{ item.label }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="等级排序：" required align="top">
            <k-input @keydown.native="clearInputSort" min="-1" type="number" placeholder="值越高，代表等级越大，从高等级开始晋升" block clearable v-model="editPara.sort"></k-input>
            <div :class="css.tip">如果该门店等级不参与晋升，则填写-1</div>
          </y-form-item>
          <y-form-item title="状态:" required>
            <div>
              <k-radio v-model="editPara.status" value="1">启用</k-radio>
              <k-radio v-model="editPara.status" value="2">停用</k-radio>
            </div>
          </y-form-item>
          <y-form-item title="备注:">
            <k-input :class="css.textarea" tag="textarea" placeholder="请输入备注" clearable v-model="editPara.remark" block maxlength="200"></k-input>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 新增/编辑弹窗区域 end -->

    <!-- 门店等级晋升规则新增/编辑区域 start -->
    <k-popup bind="v-if" okText="保存" title="门店等级晋升规则设置" :show.sync="isPromotePopupShow" @after-ok="onSavePromote">
      <div style="width: 950px; min-height: 290px;">
        <y-form titleAlign="right" titleWidth="100px" contentWidth="1000px">
          <y-form-item title="门店等级：" required>
            <k-select :class="css.inputW2" placeholder="请选择门店等级" block disabled v-model="shopGrade">
              <k-option v-for="item in shopGradeList" :key="item.value" :value="item.value" :label="item.name" :selected="shopGrade == item.value">{{ item.name }}</k-option>
            </k-select>
          </y-form-item>
          <y-form-item title="GMV：" required align="top">
            <ol class="ml-2">
              <li v-for="(item, index) in promotePara.ruleListList" :key="index" class="mb-1">
                <div style="width: 100px; display: inline-block;" v-if="index == 0"></div>
                <k-select v-else placeholder="请选择" block style="max-width: 100px; display: inline-block;" v-model="promotePara.ruleListList[index].conditionLimit">
                  <k-option v-for="item in conditionLimitList" :key="item.value" :value="item.value" :label="item.name" :selected="promotePara.ruleListList[index].conditionLimit == item.value">{{
                    item.name
                  }}</k-option>
                </k-select>
                <span :class="css.tipWord">过去</span
                ><k-input @keydown.native="clearInput" placeholder="请输入数量" style="max-width: 100px;" v-model="promotePara.ruleListList[index].mouthLimit" type="number" min="1"> </k-input
                ><span :class="css.tipWord">个月</span>
                <k-select placeholder="请选择" block style="max-width: 100px; display: inline-block;" v-model="promotePara.ruleListList[index].computeWay">
                  <k-option v-for="item in computeWayList" :key="item.value" :value="item.value" :label="item.name" :selected="promotePara.ruleListList[index].computeWay == item.value">{{
                    item.name
                  }}</k-option>
                </k-select>
                <span :class="css.tipWord">成交额 大于等于</span
                ><k-input @keydown.native="clearInput2" placeholder="请输入数量" style="max-width: 100px;" v-model="promotePara.ruleListList[index].numLimit" type="number" min="0"> </k-input
                ><span :class="css.tipWord">元</span>
                <span class="ml-2">
                  <a href="javascript:;" class="iconfont k-icon-add" title="添加" @click="onAddRule"></a>&nbsp;
                  <a href="javascript:;" class="iconfont k-icon-close-circle" title="删除" @click="onDel(index)" v-if="index > 0"></a>
                </span>
              </li>
            </ol>
          </y-form-item>
          <y-form-item title="店中店等级：" required>
            <k-select2
              block
              :data="shopInShopGradeList"
              :class="css.inputW2"
              text-field="name"
              search-field="name"
              key-field="value"
              layer-width="auto"
              layerMinWidthEqual
              :nearby="true"
              placeholder="请选择店中店等级"
              v-model="promotePara.shopInShopGrade"
            >
            </k-select2>
          </y-form-item>
          <y-form-item title="微店数：">
            <div :class="css.box">
              <k-input
                :class="css.inputW2"
                @keydown.native="clearInput"
                type="number"
                min="0"
                max="100"
                placeholder="微店数量百分比 0≤输入值≤100之间的整数"
                block
                clearable
                v-model="promotePara.smallShopNum"
              ></k-input>
              %
            </div>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 门店等级晋升规则新增/编辑区域 end -->
  </y-view>
</template>
<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_PAGELIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_ADD,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_STATUS_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_INFO,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_ADD,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_INFO_BY_GRADE_ID,
} from "@/assets/modules/apiList";
const initPara = () => ({
  shopGrade: "",
  pageSize: 15,
  pageCurrent: 1,
});
const initEditPara = () => ({
  shopGrade: "",
  shopStaffNum: "",
  shopPromotionNum: "",
  sort: "",
  isControlGoods: "",
  priceGrade: "",
  status: "1",
  remark: "",
});
const initPromotePara = () => ({
  shopGradeId: "", //门店等级ID
  shopInShopGrade: "", //店中店等级
  smallShopNum: "", //微店数量
  ruleListList: [], //规则明细
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      shopGrade: "",
      shopGradeList: [],
      shopInShopGradeList: [],
      conditionLimitList: [
        {
          value: "and",
          name: "且",
        },
        {
          value: "or",
          name: "或",
        },
      ],
      computeWayList: [
        {
          value: "count",
          name: "累计",
        },
        {
          value: "average",
          name: "平均每月",
        },
      ],
      para: initPara(),
      editPara: initEditPara(),
      promotePara: initPromotePara(),
      packCell: {
        conditionLimit: "",
        mouthLimit: 1,
        numLimit: 0,
        computeWay: "",
      },
      dataList: [],
      priceGradeList: [
        { value: "rank_one", label: "等级一" },
        { value: "rank_two", label: "等级二" },
        { value: "rank_three", label: "等级三" },
        { value: "rank_four", label: "等级四" },
        { value: "rank_five", label: "等级五" },
      ],
      controlList: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      total: 0,
      isPopupShow: false,
      isPromotePopupShow: false,
      isEdit: false,
    };
  },
  watch: {},
  methods: {
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    clearInput2(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    clearInputSort(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === ".") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    initColumns() {
      return [
        {
          name: "序号",
          field: "id",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "门店等级",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.shopGradeList.length; i++) {
              if (row.shopGrade == this.shopGradeList[i].value) {
                temp = this.shopGradeList[i].name;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "员工数量",
          field: "shopStaffNum",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "推广人数量",
          field: "shopPromotionNum",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "是否控货",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            const isControlGoods = row.isControlGoods == 1 ? <span>是</span> : <span>否</span>;
            return <div>{isControlGoods}</div>;
          },
        },
        {
          name: "价格等级",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.priceGradeList.length; i++) {
              if (row.priceGrade == this.priceGradeList[i].value) {
                temp = this.priceGradeList[i].label;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "等级排序",
          field: "sort",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "备注",
          field: "remark",
          style: {
            width: 200,
            textAlign: "center",
          },
        },
        {
          name: "启停用状态",
          field: "status",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.status}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
            width: 125,
          },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const promotedButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onPromoted(row);
                }}
              >
                晋升规则
              </a>
            );
            return (
              <div>
                {previewButton}&#12288;{editButton}&#12288;{promotedButton}
              </div>
            );
          },
        },
      ];
    },
    onView(row) {
      const { id } = row;
      this.$controller.open({
        name: "shopGradeDetail",
        query: {
          refresh: new Date() - 0,
          id,
          view: 1,
        },
        title: "查看门店等级详情",
      });
    },
    onPromoted(row) {
      this.getShopInShopGradeList();
      this.shopGrade = row.shopGrade;
      this.getRuleInfo(row.id);
      this.promotePara.shopGradeId = row.id;
      this.isPromotePopupShow = true;
    },
    onAddRule() {
      if (this.isEdit) {
        this.packCell = {
          conditionLimit: "",
          mouthLimit: 1,
          numLimit: 0,
          computeWay: "",
          shopPromotionRuleId: this.promotePara.id,
        };
      }
      this.promotePara.ruleListList.push(Object.assign({}, this.packCell));
    },
    onDel(index) {
      this.promotePara.ruleListList.splice(index, 1);
    },
    //获取门店等级列表
    getShopGradeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "storeGrade",
        },
      }).then((res) => {
        this.shopGradeList = res || [];
      });
    },
    //获取店中店等级列表
    getShopInShopGradeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "storeinstoreGrade",
        },
      }).then((res) => {
        this.shopInShopGradeList = res || [];
      });
    },
    //保存门店晋升规则
    onSavePromote() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.promotePara));
      console.log("请求参数=", para);
      if (para.smallShopNum > 100) {
        return tip("微店数量百分比 0≤输入值≤100之间的整数");
      }
      var result1 = this.promotePara.ruleListList.find((item, index) => {
        if (index > 0 && item.conditionLimit == "and") {
          return item;
        }
      });
      var result2 = this.promotePara.ruleListList.find((item, index) => {
        if (index > 0 && item.conditionLimit == "or") {
          return item;
        }
      });
      var result3 = this.promotePara.ruleListList.find((item, index) => {
        if (item.mouthLimit == "0") {
          return item;
        }
      });
      if (result1 && result2) {
        return tip("GMV各条规则只能选择相同的属性");
      }
      if (result3) {
        return tip("月份必须为大于0的整数");
      }
      for (let i = 0; i < this.promotePara.ruleListList.length; i++) {
        if (i == 0) {
          if (!this.promotePara.ruleListList[i]["mouthLimit"] || !this.promotePara.ruleListList[i]["numLimit"] || !this.promotePara.ruleListList[i]["computeWay"]) {
            return tip(`第${i + 1}条所有输入框为必填项`);
          }
        } else {
          if (
            !this.promotePara.ruleListList[i]["conditionLimit"] ||
            !this.promotePara.ruleListList[i]["mouthLimit"] ||
            !this.promotePara.ruleListList[i]["numLimit"] ||
            !this.promotePara.ruleListList[i]["computeWay"]
          ) {
            return tip(`第${i + 1}条所有输入框为必填项`);
          }
        }
      }
      this.isSaving = true;
      this.$fetch({
        api: this.isEdit ? NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_UPDATE : NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_ADD,
        para,
      })
        .then((res) => {
          tip("门店等级晋升规则保存成功");
          this.isLoading = false;
          this.isSaving = false;
          this.isPromotePopupShow = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
    // 保存门店等级信息
    onSave() {
      let { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!para.shopGrade) {
        return tip("门店等级不能为空");
      }
      if (!para.shopStaffNum && para.shopStaffNum != "0") {
        return tip("员工数量不能为空");
      }
      if (!para.shopPromotionNum && para.shopPromotionNum != "0") {
        return tip("推广人数量不能为空");
      }
      if (!para.sort && para.sort != "0") {
        return tip("等级排序不能为空");
      }
      if (parseInt(para.sort) < -1) {
        return tip("如果该门店等级不参与晋升，则填写-1");
      }
      this.isSaving = true;
      this.$fetch({
        api: this.isEdit ? NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_UPDATE : NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_ADD,
        para,
      })
        .then((res) => {
          tip("门店等级保存成功");
          this.isLoading = false;
          this.isSaving = false;
          this.isPopupShow = false;
          this.getDataList();
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
    //启停用状态切换
    onChangeStatus(row) {
      let { id, status } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.status == "1" ? "停用" : "启用"}该门店等级？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_STATUS_UPDATE,
            para: { id, status: status == "1" ? 2 : 1 },
          })
            .then(() => {
              this.isLoading = false;
              this.getDataList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    //获取列表数据
    getDataList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_PAGELIST,
        para,
      }).then((res) => {
        this.dataList = res.pageList || [];
        this.total = res.total;
      });
    },
    //条件查询列表
    onSearch() {
      this.para.pageCurrent = 1;
      this.getDataList();
    },
    //重置查询条件
    onReset() {
      this.para = initPara();
      this.getDataList();
    },
    //分页查询列表
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getDataList();
    },
    //新增
    onAdd() {
      this.isEdit = false;
      this.isPopupShow = true;
    },
    //编辑
    onEdit(row) {
      this.isEdit = true;
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_INFO,
        para: { id: row.id },
      })
        .then((res) => {
          this.editPara = res;
          this.isLoading = false;
          this.isPopupShow = true;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    //晋升规则详情
    getRuleInfo(id) {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GRADE_RULE_INFO_BY_GRADE_ID,
        para: {
          shopGradeId: id,
        },
      })
        .then((res) => {
          if (res) {
            this.promotePara = res || initPromotePara();
            this.isEdit = true;
          } else {
            this.isEdit = false;
            this.promotePara.ruleListList = [];
            this.promotePara.ruleListList.push(Object.assign({}, this.packCell));
          }
        })
        .catch(() => {
          this.promotePara = initPromotePara();
          this.promotePara.ruleListList.push(Object.assign({}, this.packCell));
        });
    },
  },
  created() {
    this.getShopGradeList();
    this.promotePara.ruleListList.push(Object.assign({}, this.packCell));
    this.getDataList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getDataList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 250px !important;
}
.inputW2 {
  width: 295px !important;
  display: inline-block !important;
  margin-right: 10px;
}
.tipWord {
  margin: 0 10px;
}
.tip {
  color: #f00;
  margin-top: 4px;
}
.textarea {
  width: 320px !important;
  height: 100px;
  & :global(.k-textarea) {
    height: 100px !important;
    resize: none;
  }
}
.box {
}
</style>
